export const baseURL = import.meta.env.VITE_API_BASE_URL;
